import { configureStore } from '@reduxjs/toolkit'
import clienteReducer from 'redux/features/cliente/cliente-slice'
import loadingReducer from 'redux/ui/loadings-slice'
import motivosReducer from 'redux/features/motivo/motivo-slice'
import cartaoReducer from 'redux/features/cartao/cartao-slice'
import desbloqueioReducer from 'redux/features/cartao/desbloqueio-slice'
import securityReducer from 'redux/features/security/security-slice'

export const store = configureStore({
  reducer: {
    cliente: clienteReducer,
    loading: loadingReducer,
    motivo: motivosReducer,
    cartao: cartaoReducer,
    cartaoDesbloqueio: desbloqueioReducer,
    security: securityReducer,
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
